module.exports = __webpack_public_path__ + "img/shape_right_trapezoid_l.b4b10bfd.svg";